import { Heading } from '../Heading';
import { ContentHeaderProps } from './types';

export const ContentHeader = ({ contentHeader, testId }: ContentHeaderProps) => (
    <Heading variant="h1" data-testid={testId} classNames={`mb-4 lg:mb-6 2xl:mb-8`}>
        {contentHeader}
    </Heading>
);
